import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/connorspackman/Developer/Cylerian/website/components/Double/Double.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/connorspackman/Developer/Cylerian/website/components/VarsHero/VarsHero.js");
;
import(/* webpackMode: "eager" */ "/Users/connorspackman/Developer/Cylerian/website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/Users/connorspackman/Developer/Cylerian/website/node_modules/next/dist/client/link.js");
